import React from "react";
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, makeStyles, Typography} from '@material-ui/core';
import {useIntl} from "react-intl";
import globalMessages from "../../../messages";
import {CALENDLY_LINK} from "../../buttons/ButtonScheduleConsultation";
import messages from "../messages";

const useStyles = makeStyles(() => ({
  actionButtons: {
    textTransform: 'none',
    justifyContent: 'flex-end'
  },
  titleStyle: {
    fontWeight: 'bold',
    textAlign: 'center'
  },
  fontWeight: {
    fontWeight: 'bold',
  },
  tableWrapper: {
    display: 'grid',
    gridTemplateColumns: '90px 150px 50px',
    gridRowGap: 6,
    marginTop: 8
  },
  rebrandTableWrapper: {
    display: 'grid',
    gridTemplateColumns: '120px 1fr',
    gridRowGap: 6
  }
}));

const StripePricingDialogInfo = ({ open, onClose } : { open: boolean, onClose?: (e: React.MouseEvent) => void }) => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  
  const handleHereClick = () => {
    window.open(CALENDLY_LINK, '_blank');
  }
  
  return (
    <Dialog onClose={onClose} open={open} maxWidth='sm' fullWidth>
      <DialogTitle>
        <Typography color="textPrimary" className={classes.titleStyle}>
          {formatMessage(messages.stripe_myFitWorld_pricing)}
          <br />
          {formatMessage(messages.stripe_myFitWorld_pricing_starting)}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography className={classes.fontWeight}>{formatMessage(messages.stripe_myFitWorld_package)}</Typography>
        
        <Box className={classes.tableWrapper}>
          <Typography variant="body2" className={classes.fontWeight}>{formatMessage(messages.stripe_myFitWorld_no_clients)}</Typography>
          <Typography variant="body2" className={classes.fontWeight}>{formatMessage(messages.stripe_myFitWorld_price)}</Typography>
          <Typography variant="body2" className={classes.fontWeight}>{formatMessage(messages.stripe_myFitWorld_discount)}</Typography>
          
          <Typography>0-4</Typography>
          <Typography variant="body2">{formatMessage(messages.stripe_myFitWorld_price_1)}</Typography>
          <Typography variant="body2"></Typography>

          <Typography>5-14</Typography>
          <Typography variant="body2">{formatMessage(messages.stripe_myFitWorld_price_2)}</Typography>
          <Typography variant="body2"></Typography>

          <Typography>15-29</Typography>
          <Typography variant="body2">{formatMessage(messages.stripe_myFitWorld_price_3)}</Typography>
          <Typography variant="body2" className={classes.fontWeight}>(-10%)</Typography>

          <Typography>30-49</Typography>
          <Typography variant="body2">{formatMessage(messages.stripe_myFitWorld_price_4)}</Typography>
          <Typography variant="body2" className={classes.fontWeight}>(-20%)</Typography>

          <Typography>50-99</Typography>
          <Typography variant="body2">{formatMessage(messages.stripe_myFitWorld_price_5)}</Typography>
          <Typography variant="body2" className={classes.fontWeight}>(-30%)</Typography>

          <Typography>100+</Typography>
          <Typography variant="body2">{formatMessage(messages.stripe_myFitWorld_price_6)}</Typography>
          <Typography variant="body2" className={classes.fontWeight}>(-50%)</Typography>
        </Box>

        <br/>
        <Typography className={classes.fontWeight}>{formatMessage(messages.stripe_myFitWorld_rebrand_users)}</Typography>

        <Box className={classes.tableWrapper}>
          <Typography variant="body2" className={classes.fontWeight}>{formatMessage(messages.stripe_myFitWorld_no_clients)}</Typography>
          <Typography variant="body2" className={classes.fontWeight}>{formatMessage(messages.stripe_myFitWorld_price)}</Typography>
          <Typography variant="body2" className={classes.fontWeight}>{formatMessage(messages.stripe_myFitWorld_discount)}</Typography>

          <Typography variant="body2">0-4</Typography>
          <Typography variant="body2" className={classes.fontWeight}>{formatMessage(messages.stripe_myFitWorld_free)}</Typography>
          <Typography variant="body2"></Typography>

          <Typography variant="body2">5-14</Typography>
          <Typography variant="body2">{formatMessage(messages.stripe_myFitWorld_price_3)}</Typography>
          <Typography variant="body2" className={classes.fontWeight}>(-10%)</Typography>

          <Typography variant="body2">15-29</Typography>
          <Typography variant="body2">{formatMessage(messages.stripe_myFitWorld_price_4)}</Typography>
          <Typography variant="body2" className={classes.fontWeight}>(-20%)</Typography>

          <Typography variant="body2">30-49</Typography>
          <Typography variant="body2">{formatMessage(messages.stripe_myFitWorld_price_5)}</Typography>
          <Typography variant="body2" className={classes.fontWeight}>(-30%)</Typography>

          <Typography variant="body2">50-99</Typography>
          <Typography variant="body2">{formatMessage(messages.stripe_myFitWorld_price_7)}</Typography>
          <Typography variant="body2" className={classes.fontWeight}>(-45%)</Typography>

          <Typography variant="body2">100+</Typography>
          <Typography variant="body2">{formatMessage(messages.stripe_myFitWorld_price_8)}</Typography>
          <Typography variant="body2" className={classes.fontWeight}>(-60%)</Typography>
        </Box>

        <br/>
        <Typography className={classes.fontWeight}>{formatMessage(messages.stripe_myFitWorld_rebrand)}</Typography>

        <Box className={classes.rebrandTableWrapper}>
          <Typography variant="body2">{formatMessage(messages.stripe_myFitWorld_month)}</Typography>
          <Typography variant="body2">19.99 EUR</Typography>

          <Typography variant="body2">{formatMessage(messages.stripe_myFitWorld_year)}</Typography>
          <Typography variant="body2">144.99 EUR</Typography>

          <Typography variant="body2">{formatMessage(messages.stripe_myFitWorld_lifetime)}</Typography>
          <Typography variant="body2">246.99 EUR</Typography>
        </Box>

        <br/>
        <Box>
          <Typography>{formatMessage(messages.stripe_myFitWorld_info_text_1)}</Typography>
          <Typography>{formatMessage(messages.stripe_myFitWorld_info_text_2)}</Typography>
        </Box>

        <br/>
        <Box>
          <Typography>{formatMessage(messages.stripe_myFitWorld_need_help)}</Typography>
          <Typography>
            {formatMessage(messages.stripe_myFitWorld_arrange_consultations)} {" "}
            <Link style={{fontSize: 18, marginBottom: 4}} component="button" onClick={handleHereClick}>
              {formatMessage(messages.stripe_myFitWorld_here_link)}
            </Link>
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions className={classes.actionButtons}>
        <Button className={classes.actionButtons} size="large" color="primary" onClick={onClose}>
          {formatMessage(globalMessages.close)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StripePricingDialogInfo;
